// Minimal DOM-based toast — works from non-component modules (e.g. db/company.js).
// Stacks up to 4 toasts, auto-dismisses after 4s, dedupes identical messages within 2s.

const CONTAINER_ID = '__toast_container__';
const recentMessages = new Map();

const ensureContainer = () => {
    if (typeof document === 'undefined') return null;
    let el = document.getElementById(CONTAINER_ID);
    if (!el) {
        el = document.createElement('div');
        el.id = CONTAINER_ID;
        Object.assign(el.style, {
            position: 'fixed',
            top: '16px',
            right: '16px',
            zIndex: '999999',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            pointerEvents: 'none',
            maxWidth: '380px'
        });
        document.body.appendChild(el);
    }
    return el;
};

const colorsFor = (type) => {
    switch (type) {
        case 'error':   return { bg: '#FEE2E2', border: '#DC2626', fg: '#7F1D1D' };
        case 'warn':    return { bg: '#FEF3C7', border: '#D97706', fg: '#78350F' };
        case 'success': return { bg: '#D1FAE5', border: '#059669', fg: '#064E3B' };
        default:        return { bg: '#E0E7FF', border: '#4F46E5', fg: '#1E1B4B' };
    }
};

export const showToast = (message, type = 'info', { duration = 4000 } = {}) => {
    if (typeof document === 'undefined') return;

    const key = `${type}::${message}`;
    const now = Date.now();
    const last = recentMessages.get(key);
    if (last && now - last < 2000) return;
    recentMessages.set(key, now);

    const container = ensureContainer();
    if (!container) return;

    while (container.children.length >= 4) container.removeChild(container.firstChild);

    const { bg, border, fg } = colorsFor(type);
    const toast = document.createElement('div');
    Object.assign(toast.style, {
        background: bg,
        color: fg,
        border: `1px solid ${border}`,
        borderLeft: `4px solid ${border}`,
        padding: '10px 14px',
        borderRadius: '6px',
        fontSize: '13px',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        opacity: '0',
        transform: 'translateX(20px)',
        transition: 'opacity 180ms ease, transform 180ms ease',
        pointerEvents: 'auto',
        cursor: 'pointer'
    });
    toast.textContent = message;

    const dismiss = () => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(20px)';
        setTimeout(() => { if (toast.parentNode === container) container.removeChild(toast); }, 200);
    };

    toast.addEventListener('click', dismiss);
    container.appendChild(toast);
    requestAnimationFrame(() => {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(0)';
    });
    setTimeout(dismiss, duration);
};

export default showToast;
